import React from "react";
import { Body, Button, Modal } from "@common/DynamicUikit";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { CombinedReducersType, ConfigActions } from "@redux/reducer";

type IProps = {
  clickClose?: () => void;
  message?: string;
};

const ErrorModal = (props: IProps) => {
  const { clickClose, message } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const config = useSelector((store: CombinedReducersType) => store.config);

  const handlerClose = () => {
    if (clickClose) {
      clickClose();
    }
    dispatch(ConfigActions.setShowWishIconError(false));
    dispatch(ConfigActions.setWishMaxError(false));
  };

  const handlerClickOkButton = () => {
    if (!config.wishMaxError) {
      window.location.reload();
    }
    handlerClose();
  };

  return (
    <Modal
      closeLabel={" "}
      closeTitle={t("text_a11y_close")}
      errors={[]}
      id="wish-error-modal"
      labelElement="h5"
      onBackdropClick={undefined}
      onRequestClose={handlerClose}
      title={t("text_system_error")}
      titleId="wish-error-title"
      trapFocus
      variant="small"
      isOpen
      footer={
        <Button
          element="button"
          variant="primary"
          width="fullWidth"
          onClick={handlerClickOkButton}
        >
          {t("text_ok")}
        </Button>
      }
    >
      <Body element="p">{message || t("text_error_description")}</Body>
    </Modal>
  );
};

export default ErrorModal;
